const q=({sdkUrl:a,serverUrl:t,clientCode:c,apiKey:n,storeId:u})=>a&&t&&c&&n&&u,z=({enable:a=!1})=>a,T=({enable:a,serverUrl:t,clientCode:c,apiKey:n,storeId:u})=>{if(!a||!t||!c||!n||!u)return;const f=window.theme.locale.isoCode??"en",h=window.theme.localization.country??"AU";window.Tagalys.setConfiguration({api:{serverUrl:t,credentials:{clientCode:c,apiKey:n},storeId:u},locale:`${f}-${h}`,currency:{displayFormatter:"{{currencyLabel}}{{value}}",code:window.theme.localization.currency??"AUD",label:window.theme.localization.currencySymbol??"$",fractionalDigits:2,forceFractionalDigits:!0},analyticsStorageConsentProvided(){return!0},track:!0})},H=({enable:a,storefrontApiAccessToken:t})=>{var n,u;if(!a)return;const c=[{namespace:"card",key:"badges"},{namespace:"card",key:"message"},{namespace:"shopify",key:"color-pattern"}];window.Tagalys.setPlatformConfiguration({platform:"Shopify",countryCode:((n=window.theme.localization)==null?void 0:n.country)??"AU",baseCountryCode:((u=window.theme.localization)==null?void 0:u.baseCountry)??"AU",useStorefrontAPIForSecondaryMarkets:!!t,waitForStorefrontAPI:!!t,storefrontAPI:{accessToken:t,myShopifyDomain:window.Shopify.shop},metafields:{products:c}})},F=a=>{const t=setInterval(()=>{if(!window.Tagalys||!window.tagalysReady){window.console.error("TWP | onTagalysReady | Tagalys is not ready");return}clearInterval(t),typeof a=="function"&&a()},150)},j=()=>{const a=window.theme.tagalys;if(!a||!q(a)||!z(a))return;const t=setInterval(()=>{if(!window.Tagalys){window.console.error("TWP | tagalysInit | Tagalys has not loaded");return}clearInterval(t),T(window.theme.tagalys),H(window.theme.tagalys),console.log("TWP | window.theme.tagalys",window.theme.tagalys),window.tagalysReady=!0,document.dispatchEvent(new Event("tagalys:ready"))},150)},B=a=>{const t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${a.handle}`},S=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),A=(a,t)=>{const c=t.getTemplateOptions("product"),n=c.productPageUrl(a),u=t.getPrice?t.getPrice(a):a.price,f=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,h=t.isProductOnSale(f,u),m=a.images,v=m?m.length:0,C=a.featured_image||(m&&m.length>0?m[0]:null);let y="default";v>1&&(y=c.forceHoverGallery?"hover":"gallery");const k=()=>{var p,o,d;let l="";if(h&&(l+='<div class="product-card__badge badge body-extra-small">Sale<span>%</span></div>'),(d=(o=(p=a.metafields)==null?void 0:p.card)==null?void 0:o.badges)!=null&&d.value)for(const i of a.metafields.card.badges.value)l+=`<div class="product-card__badge badge body-extra-small">${i.name}</div>`;return l?`<div class="product-card__badges">${l}</div>`:""},g=()=>{var p,o,d;let l="";if(a.options_with_values){for(const i of a.options_with_values)if(i.name==="Size"){let s="";for(const e of i.values){const r=a.variants.find($=>$.option1===e||$.option2===e||$.option3===e),_=r?r.available:!1;s+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${c.context||"card"}-${a.id}-option-${S(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(r==null?void 0:r.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${_?"":"disabled"}
                >
                <label
                  for="${c.context||"card"}-${a.id}-option-${S(e)}"
                  ${_?"":"disabled"}
                  class="quick-add-form__variant-label${_?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                </label>
              </div>
            `}l+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${c.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${s}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(i.name==="Colour"||i.name==="Color"){let s="";for(let e=0;e<Math.min(i.values.length,3);e++){const r=i.values[e],_=a.variants.find(P=>P.option2===r),$=(o=(p=r.swatch)==null?void 0:p.color)==null?void 0:o.rgba,x=(d=r.swatch)==null?void 0:d.image;s+=`
                <input
                  type="radio"
                  id="${c.context||"card"}-${a.id}-color-${S(r)}"
                  name="Color"
                  value="${r}"
                  data-variant-id="${(_==null?void 0:_.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${r.selected?"checked":""}
                >
                <label
                  for="${c.context||"card"}-${a.id}-color-${S(r)}"
                  class="quick-add-form__variant-label--swatch${x?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${r.product_url||""}"
                  data-swatch
                  data-color="${S(r)}"
                  ${$||x?`style="${$?`background-color: rgba(${$}); --swatch-color: rgba(${$});`:""}${x?`background-image: url(${x});`:""}"`:`style="--swatch-color: var(--swatch-color-${S(r)});"`}
                >
                  <span class="visually-hidden">${r}</span>
                </label>
              `}i.values.length>3&&(s+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${i.values.length-3}</span>
                </div>
              `),l+=`
              <div class="quick-add-form__color-swatches">
                ${c.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${s}
              </div>
            `}}return l},b=()=>h?`
        <span class="product-card__price--sale">${t.formatCurrency(u)}</span>
        <s class="product-card__price--compare">${t.formatCurrency(f)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(u)}</span>`,w=()=>{if(y==="gallery"&&v>1){let l="";for(let p=0;p<Math.min(v,3);p++){const o=m[p];l+=`
          <a href="${n}" class="product-card__gallery-item" data-slide>
            <img src="${o.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${l}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(y==="hover"&&v>1){let l="";for(let p=0;p<Math.min(v,2);p++){const o=m[p];l+=`<img src="${o.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${n}" class="product-card__hover-gallery">
          ${l}
        </a>
      `}else return`
        <a class="product-card__default-image" href="${n}">
          ${C?`<img src="${C.src}" alt="${a.title}" loading="lazy">`:'<div class="placeholder-image"><p class="site-title">CDP</p></div>'}
        </a>
      `};return`
    <product-card
      data-product-card
      class="product-card"
      data-product-handle="${a.handle}"
      data-template-type="${c.forceHoverGallery&&v>1?"card-hover":"card"}"
    >
      <div class="product-card__media">
        ${k()}
        ${w()}
      </div>
      <div class="product-card__meta-wrapper">
        <div class="product-card__meta">
          <p class="product-card__title">${a.title.split(" - ")[0]}</p>
          <div class="product-card__price">
            ${b()}
          </div>
          <div class="product-card__quick-add-form">
            ${g()}
          </div>
          <button
            class="product-card__quick-add-button"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||n}"
          >
            <svg class="icon icon-bag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.5V5.5C8 3.567 9.567 2 11.5 2C13.433 2 15 3.567 15 5.5V7.5M3 7.5H20V20.5C20 21.328 19.328 22 18.5 22H4.5C3.672 22 3 21.328 3 20.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </product-card>
  `},L=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),U=(a,t)=>{const c=t.getTemplateOptions("product"),n=c.productPageUrl(a),u=t.getPrice?t.getPrice(a):a.price,f=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,h=f>u,m=a.images,v=m?m.length:0,C=window.theme.productCard.maxSlides,y=v<C?v:C;let k="gallery";v<=1&&(k="default"),v===0&&(k="empty"),c.forceHoverGallery&&(k="hover");const g=()=>{let d="";if(a.options_with_values){for(const i of a.options_with_values)if(i.name==="Size"){let s="";for(const e of i.values){const r=(e==null?void 0:e.name)||e,_=a.variants.find(x=>x.option1===r||x.option2===r||x.option3===r),$=_?_.available:!1;s+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${c.context||"card"}-${a.id}-option-${L(r)}"
                  name="Size"
                  value="${r}"
                  data-variant-id="${(_==null?void 0:_.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${$?"":"disabled"}
                >
                <label
                  for="${c.context||"card"}-${a.id}-option-${L(r)}"
                  ${$?"":"disabled"}
                  class="quick-add-form__variant-label${$?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${r}</span>
                </label>
              </div>
            `}d+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${c.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${s}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}}return`
      <div class="quick-add-form__variant-options">
        ${d}
      </div>
    `},b=()=>{const d=a.tags||[],i=d.some(r=>r.includes("badge:"));if(!(h||i))return"";let e="";if(h)e=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round((f-u)*100/f)}%</span>
        </div>
      `;else{let r=!1;if(!r){for(const _ of d)if(_.includes("badge:use-code-")){e=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${_.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,r=!0;break}}if(!r&&d.includes("badge:trending")&&(e='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',r=!0),!r&&d.includes("badge:low-in-stock")&&(e='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',r=!0),!r){for(const _ of d)if(_.includes("badge:custom-")){e=`<div class="product-card__badge badge product-card__badge--custom">${_.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,r=!0;break}}!r&&d.includes("badge:coming-soon")&&(e='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',r=!0),!r&&d.includes("badge:sold-out")&&(e='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',r=!0),!r&&d.includes("badge:pre-order")&&(e='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',r=!0),!r&&d.includes("badge:most-loved")&&(e='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',r=!0),!r&&d.includes("badge:best-seller")&&(e='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',r=!0),!r&&d.includes("badge:new")&&(e='<div class="product-card__badge badge product-card__badge--new">New</div>',r=!0)}return e?`<div class="product-card__badges">${e}</div>`:""},w=()=>f>u?`
        <span class="product-card__price--sale">${t.formatCurrency(u)}</span>
        <s class="product-card__price--compare">${t.formatCurrency(f)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(u)}</span>`,l=()=>{if(k==="gallery"&&v>1){let d="";for(let i=0;i<Math.min(v,C);i++){const s=m[i];d+=`
          <a href="${n}" class="product-card__gallery-item" data-slide>
            <img src="${s.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${d}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-pagination body-small" data-pagination>
            <span>1</span><span>/</span><span>${y}</span>
          </div>
        </div>
      `}else if(k==="hover"&&v>1){let d="";for(let i=0;i<Math.min(v,2);i++){const s=m[i];d+=`<img src="${s.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${n}" class="product-card__hover-gallery">
          ${d}
        </a>
      `}else if(k==="default"){const d=a.featured_image;return`
        <a class="product-card__default-image" href="${n}">
          ${d?`<img src="${d.src}" alt="${a.title}" loading="lazy">`:""}
        </a>
      `}else return'<div class="product-card__gallery-item-image placeholder-svg"></div>'},p=()=>{var i,s,e;return`
      <div class="product-card__meta">
        ${(e=(s=(i=a.metafields)==null?void 0:i.card)==null?void 0:s.badges)!=null&&e.value?`
      <div class="product-card__badges--mobile">
        ${b()}
      </div>
    `:""}
        <p class="product-card__title">${a.title.split(" - ")[0]}</p>
        <div class="product-card__price">
          ${w()}
        </div>
        <div class="product-card__form-wrapper">
          <div class="product-card__quick-add-form">
            ${g()}
          </div>
        </div>
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${b()}
        ${l()}
        <button
          class="product-card__quick-add-button"
          type="button"
          data-quick-add-modal-toggle
          data-product-url="${a.url||n}"
        >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6H17L16.165 15.181C16.1198 15.6779 15.8906 16.14 15.5222 16.4766C15.1538 16.8131 14.673 16.9998 14.174 17H3.826C3.32704 16.9998 2.84617 16.8131 2.4778 16.4766C2.10942 16.14 1.88016 15.6779 1.835 15.181L1 6Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M5 8V5C5 3.93913 5.42143 2.92172 6.17157 2.17157C6.92172 1.42143 7.93913 1 9 1C10.0609 1 11.0783 1.42143 11.8284 2.17157C12.5786 2.92172 13 3.93913 13 5V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        </button>
      </div>
      ${p()}
    </product-card>
  `},M=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),I=(a,t)=>{const c=t.getTemplateOptions("product"),n=c.productPageUrl(a),u=t.getPrice?t.getPrice(a):a.price,f=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,h=f>u,m=a.images,v=m?m.length:0,C=3;let y="hover";v<=1&&(y="default"),c.forceGallery&&(y="gallery");const k=()=>{let o="";if(a.options_with_values){for(const d of a.options_with_values)if(d.name==="Size"){let i="";for(const s of d.values){const e=(s==null?void 0:s.name)||s,r=a.variants.find($=>$.option1===e||$.option2===e||$.option3===e),_=r?r.available:!1;i+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${c.context||"card"}-${a.id}-option-${M(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(r==null?void 0:r.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${_?"":"disabled"}
                >
                <label
                  for="${c.context||"card"}-${a.id}-option-${M(e)}"
                  ${_?"":"disabled"}
                  class="quick-add-form__variant-label${_?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                  <svg aria-label="Tick icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1198_25368)">
                  <path d="M6.90909 11L6.55874 11.3567C6.75324 11.5478 7.06494 11.5478 7.25945 11.3567L6.90909 11ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14.5ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5V0.5C3.85786 0.5 0.5 3.85786 0.5 8H1.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V1.5ZM3.64965 8.49958L6.55874 11.3567L7.25945 10.6433L4.35035 7.78613L3.64965 8.49958ZM7.25945 11.3567L12.3504 6.35672L11.6496 5.64328L6.55874 10.6433L7.25945 11.3567Z" fill="currentColor" />
                  </g>
                  <defs>
                  <clipPath id="clip0_1198_25368">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </label>
              </div>
            `}o+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${c.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${i}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}}return o},g=()=>{const o=a.tags||[],d=o.some(e=>e.includes("badge:"));if(!(h||d))return"";let s="";if(h)s=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round((f-u)*100/f)}%</span>
        </div>
      `;else{let e=!1;if(!e){for(const r of o)if(r.includes("badge:use-code-")){s=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${r.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}if(!e&&o.includes("badge:trending")&&(s='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',e=!0),!e&&o.includes("badge:low-in-stock")&&(s='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',e=!0),!e){for(const r of o)if(r.includes("badge:custom-")){s=`<div class="product-card__badge badge product-card__badge--custom">${r.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}!e&&o.includes("badge:coming-soon")&&(s='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',e=!0),!e&&o.includes("badge:sold-out")&&(s='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',e=!0),!e&&o.includes("badge:pre-order")&&(s='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',e=!0),!e&&o.includes("badge:most-loved")&&(s='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',e=!0),!e&&o.includes("badge:best-seller")&&(s='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',e=!0),!e&&o.includes("badge:new")&&(s='<div class="product-card__badge badge product-card__badge--new">New</div>',e=!0)}return s?`<div class="product-card__badges">${s}</div>`:""},b=()=>`
      <div class="product-card__price-wrapper">
        ${h?`<s class="product-card__price--compare">${t.formatCurrency(f)}</s>`:""}
        <span class="product-card__price--${h?"sale":"regular"}">${t.formatCurrency(u)}</span>
      </div>
    `,w=()=>{if(y==="gallery"&&v>1){let o="";for(let d=0;d<Math.min(v,C);d++){const i=m[d];o+=`
          <a href="${n}" class="product-card__gallery-item" data-slide>
            <img src="${i.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${o}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(y==="hover"&&v>1){let o="";for(let d=0;d<Math.min(v,2);d++){const i=m[d];o+=`<img src="${i.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${n}" class="product-card__hover-gallery">
          ${o}
        </a>
      `}else{const o=a.featured_image;return`
        <a class="product-card__default-image" href="${n}">
          ${o?`<img src="${o.src}" alt="${a.title}" loading="lazy" placeholder="product">`:'<div class="product-card__placeholder placeholder-svg"></div>'}
        </a>
      `}},l=()=>`
      <button class="product-card__wishlist-button product-card__cta" type="button">
        <svg class="icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,p=()=>{const o=`
      <div class="product-card__badges-mobile">
        ${g()}
      </div>
    `;return`
      <div class="product-card__meta">
        <p class="product-card__title">${a.title.charAt(0).toUpperCase()+a.title.slice(1).toLowerCase().split(" - ")[0]}</p>
        <div class="product-card__price">
          ${b()}
        </div>
        ${o}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${g()}
        ${l()}
        ${w()}
        <div class="product-card__ctas">
          <button
            class="product-card__quick-add-button product-card__cta"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||n}"
          >
            <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${l()}
        </div>
        <div class="product-card__quick-add-form">
          ${k()}
        </div>
      </div>
      ${p()}
    </product-card>
  `},O=(a,t)=>{var u;const c=((u=window.theme)==null?void 0:u.brandEnvironment)||"cdp";switch(c==="gia"?"iamgia":c){case"iamgia":return U(a,t);case"tigermist":return I(a,t);case"cdp":default:return A(a,t)}},Z=(a,t)=>{var m,v,C,y,k;const c=((m=t==null?void 0:t.dataset)==null?void 0:m.sectionId)||"no-results",n=(v=t==null?void 0:t.dataset)==null?void 0:v.title,u=(C=t==null?void 0:t.dataset)==null?void 0:C.headingSize,f=(y=t==null?void 0:t.dataset)==null?void 0:y.buttonLabel,h=(k=t==null?void 0:t.dataset)==null?void 0:k.buttonUrl;return{widget:{options:{limit:a,displayFormat:"grid",includeTagalysCSS:!1},render:(g,b)=>{const w=b.props,p=w.helpers.getProducts();if(w.loading===!1)return p.length===0?null:g`
            <${b.templates.title} />
            <${b.templates.productList} />
            <${b.templates.button} />
          `}},title:{render:g=>n?g`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${u}">${n}</h2>
            </div>
          `:g``},productList:{render:(g,b)=>g`
        <slider-component class="slider-component-full-width">
          <${b.templates.products} />
        </slider-component>
      `},products:{render:(g,b)=>{const l=b.props.helpers.getProducts();return g`<ul
          id="Slider-${c}"
          class="results-grid results-grid--default list-inline m-results-grid--2"
        >
          ${l.map((p,o)=>g`<li class="results-grid__tile">
                <${b.templates.product} key=${o} product=${p} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl(g){return B(g)}},render:(g,b)=>{const w=b.props,l=w.product,p=w.helpers;return g`<div
          class="tagalys-section__slide"
          id="Slide-${l.id}"
          dangerouslySetInnerHTML=${{__html:O(l,p)}}
        />`}},carouselActions:{render:g=>{var b,w,l,p,o,d;return g`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(l=(w=(b=window.theme)==null?void 0:b.strings)==null?void 0:w.accessibility)==null?void 0:l.previousSlide}"
            aria-controls="Slider-${c}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(d=(o=(p=window.theme)==null?void 0:p.strings)==null?void 0:o.accessibility)==null?void 0:d.nextSlide}"
            aria-controls="Slider-${c}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:g=>f&&h?g`
            <div class="product-recommendations__button">
              <a href="${h}" class="button button--secondary">${f}</a>
            </div>
          `:g``}}};export{B as c,j as i,F as o,O as r,Z as t};
